// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile h4 {
    font-size: 14px;
    color: #000000;
    margin-bottom: 40px;
}

.profile .profile-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.profile .profile-content {
    width: 700px;
    border: 1px solid #E6E6E6;
    margin-bottom: 30px;
}

.profile .profile-content .header {
    padding: 20px;
    background-color: #F5F5F5;
    border-bottom: 1px solid #E6E6E6;
}

.profile .profile-content .main {
    padding: 20px;
}

.profile .profile-content .details {
    background-color: #EEEEEE;
    padding: 8px 20px;
}

.profile .profile-content .details h6 {
    margin-bottom: 5px;
    font-size: 10px;
    color: #A0A0A0;
}

.profile .profile-content .details p {
    margin-bottom: 0;
    font-size: 12px;
    color: #6A6A6A;
}

.profile .profile-content .btn {
    width: 100%;
    height: 100%;
    border: 1px solid #3381F2;
    background-color: transparent;
    color: #3381F2;
}

.profile .profile-content .cancel {
    width: 15%;
    border: 1px solid #A0A0A0;
    color: #A0A0A0;
}

.profile .profile-content .footer {
    padding: 20px;
    background-color: #F5F5F5;
    border-top: 1px solid #E6E6E6;
}

.profile .profile-container .grouped-input {
    background-color: #EEEEEE;
    border: none;
    border-radius: 4px;
    padding: 2px 8px;
}

.profile .profile-container .grouped-input label {
    font-size: 10px;
    color: #A0A0A0;
}

.profile .profile-container .grouped-input input {
    background-color: transparent;
    border: none;
    padding: 0;
    box-shadow: none;
}

.profile .profile-container .grouped-input small {
    color: #E86880;
}
`, "",{"version":3,"sources":["webpack://./src/view/reporting-dashboard/onboarding/Profile.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".profile h4 {\n    font-size: 14px;\n    color: #000000;\n    margin-bottom: 40px;\n}\n\n.profile .profile-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.profile .profile-content {\n    width: 700px;\n    border: 1px solid #E6E6E6;\n    margin-bottom: 30px;\n}\n\n.profile .profile-content .header {\n    padding: 20px;\n    background-color: #F5F5F5;\n    border-bottom: 1px solid #E6E6E6;\n}\n\n.profile .profile-content .main {\n    padding: 20px;\n}\n\n.profile .profile-content .details {\n    background-color: #EEEEEE;\n    padding: 8px 20px;\n}\n\n.profile .profile-content .details h6 {\n    margin-bottom: 5px;\n    font-size: 10px;\n    color: #A0A0A0;\n}\n\n.profile .profile-content .details p {\n    margin-bottom: 0;\n    font-size: 12px;\n    color: #6A6A6A;\n}\n\n.profile .profile-content .btn {\n    width: 100%;\n    height: 100%;\n    border: 1px solid #3381F2;\n    background-color: transparent;\n    color: #3381F2;\n}\n\n.profile .profile-content .cancel {\n    width: 15%;\n    border: 1px solid #A0A0A0;\n    color: #A0A0A0;\n}\n\n.profile .profile-content .footer {\n    padding: 20px;\n    background-color: #F5F5F5;\n    border-top: 1px solid #E6E6E6;\n}\n\n.profile .profile-container .grouped-input {\n    background-color: #EEEEEE;\n    border: none;\n    border-radius: 4px;\n    padding: 2px 8px;\n}\n\n.profile .profile-container .grouped-input label {\n    font-size: 10px;\n    color: #A0A0A0;\n}\n\n.profile .profile-container .grouped-input input {\n    background-color: transparent;\n    border: none;\n    padding: 0;\n    box-shadow: none;\n}\n\n.profile .profile-container .grouped-input small {\n    color: #E86880;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
